













































































import { Vue, Component, Prop, PropSync } from 'vue-property-decorator'
import type { ConfiguracaoDeNotificacaoPorEmail, ConfiguracaoDeNotificacaoPorUsuario, FormLoja } from '@/models'
import RevealPasswordField from '@/components/ui/RevealPasswordField.vue'
import ListaDeNotificacoesPorConfigPorUsuario from '@/components/usuario/ListaDeNotificacoesPorConfigPorUsuario.vue'
import ListaDeNotificacoesPorConfigPorEmail from '@/components/usuario/ListaDeNotificacoesPorConfigPorEmail.vue'

@Component({
	components: { RevealPasswordField, ListaDeNotificacoesPorConfigPorUsuario, ListaDeNotificacoesPorConfigPorEmail },
})
export default class BlocoServidorDeEmail extends Vue {
	@Prop({ type: Object, required: true }) loja!: FormLoja
	@PropSync('configuracoesPorUsuario', { type: Array, default: () => [] }) porUsuario!: ConfiguracaoDeNotificacaoPorUsuario[]
	@PropSync('configuracoesPorEmail', { type: Array, default: () => [] }) porEmail!: ConfiguracaoDeNotificacaoPorEmail[]

	// Os mesmos módulos e na mesma ordem da tela antiga
	MODULOS = [
		{ valor: 'Estoque', rotulo: 'Estoque' },
		{ valor: 'Vendas', rotulo: 'Vendas' },
		{ valor: 'Nota em Transito', rotulo: 'Nota em trânsito' },
	]
	abaPorUsuario = 0
	abaPorEmail = 0

	get configuracao() {
		return this.loja.configuracaoDaLoja
	}
}
